import { get, post } from './http'

export const getBrand = p => post('h5/v1/brand/query', p); //获取品牌
export const submitSettled  = p => post('h5/v1/apply/for', p); //提交审核
export const sendVcode  = p => post('h5/v1/send/msg/code', p); // 发送验证码
export const verifyCode  = p => post('h5/v1/msg/applyfor/chick', p); // 验证验证码
export const submitSettled2  = p => post('h5/v1/subscribe/apply/three', p); // 提交审核2
export const upSettled2  = p => post('h5/v1/image/apply/upload', p); // 上传图片
export const shares  = p => post('h5/v1/buss/js/signature', p); // 微信jssdk
export const getFlow = p => post('h5/v1/business/operate/course/one', p); //获取操作流程数据
export const getMiniprogramLink = p => post('/h5/v1/get/miniprogram/url/link', p); //获取小程序跳转链接
export const getComment = p => post('/h5/v1/comment/one', p); //获取评论












// WEBPACK FOOTER //
// ./src/request/api.js